import { Outlet } from 'react-router-dom';

import { TopBar } from '@/widgets/header';

// User menu pages are above domains and yachts, so they have no context bar and no sidebar
export const AccountLayout = () => (
	<div className="flex h-screen flex-col">
		<TopBar />
		<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
			<Outlet />
		</div>
	</div>
);
